function itemSupportsRotation(item) {
  return item.kind === "image" || item.kind === "legacyCanvasShape" || item.kind === "shape";
}

export { itemSupportsRotation };
//# sourceMappingURL=itemSupportsRotation.js.map
